import React from "react";
import { Result, Button } from "antd";

const ServerErrorPageComponent = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Result
        status="500"
        title="Internal Error Occurred"
        subTitle="Something went wrong on our end. We are already working to fix it. Please check back later."
        extra={
          <Button type="primary" onClick={handleRefresh}>
            Refresh
          </Button>
        }
      />
    </div>
  );
};

export default ServerErrorPageComponent;
